import { useRef } from 'react';
import { msPerStep } from './constants';

const msPerPoint = msPerStep * 2;

const useGameScoreRefs = () => {
  const scoreElementRef = useRef<HTMLDivElement>(null);
  const scoreTrackerRef = useRef({
    msCounter: 0,
    value: 0,
    incrementScore(msDelta: number) {
      this.msCounter += msDelta;
      this.value = Math.floor(this.msCounter / msPerPoint);
      if (scoreElementRef.current) {
        scoreElementRef.current.textContent = String(this.value).padStart(2, '0');
      }
    },
    reset() {
      this.msCounter = 0;
      this.value = 0;
      if (scoreElementRef.current) {
        scoreElementRef.current.textContent = String(this.value).padStart(2, '0');
      }
    }
  });

  return [scoreElementRef, scoreTrackerRef] as const;
};

export default useGameScoreRefs;
